<template>
  <blockquote
    v-if="getQuoteText()"
    class="ao__quote"
  >
    <DefaultIconsQuote />
    <p v-html="getQuoteText()" />
  </blockquote>

</template>


<script setup lang="ts">
const {payload} = defineProps<{
  payload?: any
}>()

const getQuoteText = () => {
  const result = payload.content.find((item) => item.type === 'quote_author')

  return result?.contentHTML
}

</script>

<style lang="postcss" scoped>
</style>
